<template>
  <div class="config-page">
    <!-- 顶栏 -->
    <div class="topbar">
      <div class="topbar-left">
        <el-button type="text" icon="el-icon-arrow-left" @click="goBack">返回设备列表</el-button>
        <span class="bc-sep">/</span>
        <span class="bc-cur">服药提醒配置</span>
      </div>
      <el-button type="primary" :loading="sendLoading" icon="el-icon-upload2" @click="handleSend">
        下发配置
      </el-button>
    </div>

    <!-- 设备信息 -->
    <el-card shadow="never" class="device-card">
      <div class="device-info">
        <span class="device-dot" :class="deviceInfo.onlineStatus === 1 ? 'online' : 'offline'"></span>
        <span class="device-no">{{ deviceNo }}</span>
        <span class="sep">·</span>
        <span>{{ oldmanName }}</span>
        <span class="sep">·</span>
        <span class="meta">固件 {{ deviceInfo.firmwareVersion || '-' }}</span>
        <span class="sep">·</span>
        <span class="meta">电量
          <span :style="{ color: getBatteryColor(deviceInfo.battery) }">
            {{ deviceInfo.battery != null ? deviceInfo.battery + '%' : '-' }}
          </span>
        </span>
        <span class="sep">·</span>
        <span class="meta">信号 {{ getSignalLabel(deviceInfo.signalStrength) }}</span>
        <el-tag :type="getSendStatusType(deviceInfo.sendStatus)" size="mini" style="margin-left:12px">
          {{ getSendStatusLabel(deviceInfo.sendStatus) }}
        </el-tag>
      </div>
    </el-card>

    <!-- 提醒时间设置 -->
    <el-card shadow="never" class="section-card">
      <div slot="header" class="section-header">
        <i class="el-icon-time" style="color:#409eff;margin-right:6px"></i>
        提醒时间设置
        <span class="hint">0000 = 关闭该时间点</span>
      </div>

      <el-row :gutter="12">
        <el-col :span="3" v-for="item in timeFields" :key="item.key">
          <div class="time-field">
            <div class="time-label">{{ item.label }}</div>
            <el-input v-model="configForm[item.key]" placeholder="0000" maxlength="4" size="small" />
          </div>
        </el-col>
      </el-row>

      <el-divider />

      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item label="提前服药时长（分钟）" label-width="160px">
            <el-input-number v-model="configForm.advanceTime" :min="0" :max="120" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="超时服药时长（分钟）" label-width="160px">
            <el-input-number v-model="configForm.timeoutTime" :min="0" :max="120" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="播放音量（0-7）" label-width="130px">
            <el-input-number v-model="configForm.volume" :min="0" :max="7" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="有效期" label-width="60px">
            <el-date-picker v-model="dateRange" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期"
              value-format="yyyyMMdd" size="small" @change="onDateChange" style="width:100%" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-divider content-position="left">自定义提醒时间</el-divider>
      <el-row :gutter="12">
        <el-col :span="4" v-for="i in 5" :key="i">
          <div class="time-field">
            <div class="time-label">其他提醒{{ i }}</div>
            <el-input v-model="configForm['otherTime' + i]" placeholder="0000" maxlength="4" size="small" />
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 服药医嘱配置 -->
    <el-card shadow="never" class="section-card">
      <div slot="header" class="section-header">
        <i class="el-icon-first-aid-kit" style="color:#67c23a;margin-right:6px"></i>
        服药医嘱配置
        <div style="margin-left:auto;display:flex;align-items:center;gap:8px">
          <span style="font-size:13px;color:#606266">自动播放语音</span>
          <el-switch v-model="configForm.autoPlay" :active-value="1" :inactive-value="0" />
        </div>
      </div>

      <el-table :data="drugFields" border size="small" style="width:100%">
        <el-table-column label="餐次" prop="label" width="80" align="center" />
        <el-table-column label="服药描述（语音播报文本）">
          <template slot-scope="scope">
            <el-input v-model="configForm[scope.row.descKey]" placeholder="如：维生素C片1粒，降压药1片" size="small" />
          </template>
        </el-table-column>
        <el-table-column label="药品详情（名*数量格式）">
          <template slot-scope="scope">
            <el-input v-model="configForm[scope.row.detailKey]" placeholder="如：维生素C片*1*降压药*1" size="small" />
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top:12px">
        <div class="time-label" style="margin-bottom:8px">其他提醒内容</div>
        <el-row :gutter="12">
          <el-col :span="8" v-for="i in 5" :key="i">
            <el-form-item :label="'其他提醒' + i" label-width="80px">
              <el-input v-model="configForm['otherRemind' + i]" placeholder="如：测量两次血压，做好记录" size="small" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import bus from "@/vuex/eventBus";

export default {
  data() {
    return {
      sendLoading: false,
      deviceInfo: {},
      dateRange: [],
      deviceNo: '',
      oldmanName: '',
      timeFields: [
        { key: 'breakfastBefore', label: '早餐前' },
        { key: 'breakfastAfter',  label: '早餐后' },
        { key: 'lunchBefore',     label: '午餐前' },
        { key: 'lunchAfter',      label: '午餐后' },
        { key: 'dinnerBefore',    label: '晚餐前' },
        { key: 'dinnerAfter',     label: '晚餐后' },
        { key: 'bedtime',         label: '睡前'   },
      ],
      drugFields: [
        { label: '早餐前', descKey: 'breakfastBeforeDrug',  detailKey: 'breakfastBeforeDrugDetail' },
        { label: '早餐后', descKey: 'breakfastAfterDrug',   detailKey: 'breakfastAfterDrugDetail'  },
        { label: '午餐前', descKey: 'lunchBeforeDrug',      detailKey: 'lunchBeforeDrugDetail'     },
        { label: '午餐后', descKey: 'lunchAfterDrug',       detailKey: 'lunchAfterDrugDetail'      },
        { label: '晚餐前', descKey: 'dinnerBeforeDrug',     detailKey: 'dinnerBeforeDrugDetail'    },
        { label: '晚餐后', descKey: 'dinnerAfterDrug',      detailKey: 'dinnerAfterDrugDetail'     },
        { label: '睡前',   descKey: 'bedtimeDrug',          detailKey: 'bedtimeDrugDetail'         },
      ],
      configForm: {
        deviceNo: '',
        startDate: '', endDate: '',
        breakfastBefore: '0000', breakfastAfter: '0000',
        lunchBefore: '0000', lunchAfter: '0000',
        dinnerBefore: '0000', dinnerAfter: '0000',
        bedtime: '0000',
        otherTime1: '0000', otherTime2: '0000', otherTime3: '0000', otherTime4: '0000', otherTime5: '0000',
        advanceTime: 30, timeoutTime: 30, volume: 5,
        breakfastBeforeDrug: '', breakfastAfterDrug: '', lunchBeforeDrug: '', lunchAfterDrug: '',
        dinnerBeforeDrug: '', dinnerAfterDrug: '', bedtimeDrug: '',
        breakfastBeforeDrugDetail: '', breakfastAfterDrugDetail: '', lunchBeforeDrugDetail: '',
        lunchAfterDrugDetail: '', dinnerBeforeDrugDetail: '', dinnerAfterDrugDetail: '', bedtimeDrugDetail: '',
        otherRemind1: '', otherRemind2: '', otherRemind3: '', otherRemind4: '', otherRemind5: '',
        autoPlay: 1,
      },
    };
  },
  methods: {
    loadConfig() {
      this.$postJson('dmc/medicineBox/getDeviceConfig', { deviceNo: this.deviceNo }).then(res => {
        const data = res.result || res;
        if (data) {
          Object.assign(this.configForm, data);
          if (data.startDate && data.endDate) {
            this.dateRange = [data.startDate, data.endDate];
          }
        }
      });
      this.$postJson('dmc/medicineBox/getDeviceInfo', { deviceNo: this.deviceNo }).then(res => {
        const data = res.result || res;
        if (data) Object.assign(this.deviceInfo, data);
      });
    },
    onDateChange(val) {
      this.configForm.startDate = val && val[0] ? val[0] : '';
      this.configForm.endDate   = val && val[1] ? val[1] : '';
    },
    handleSend() {
      if (!this.configForm.startDate || !this.configForm.endDate) {
        this.$message.warning('请选择有效期'); return;
      }
      this.sendLoading = true;
      this.$postJson('dmc/medicine/remind/save', { ...this.configForm, deviceNo: this.deviceNo }).then(res => {
        if (res && res.code == 200) {
          this.$message.success('配置下发成功，等待设备确认');
          this.loadConfig();
        }
      }).finally(() => { this.sendLoading = false; });
    },
    goBack() {
      bus.$emit('close_current_tags');
    },
    getBatteryColor(v) {
      if (v == null) return '#909399';
      return v <= 20 ? '#f56c6c' : v <= 50 ? '#e6a23c' : '#67c23a';
    },
    getSignalLabel(v) {
      if (v == null) return '-';
      return v <= 5 ? '极弱' : v <= 10 ? '弱' : v <= 20 ? '中' : '强';
    },
    getSendStatusLabel(v) {
      return { 0: '未配置', 1: '已下发', 2: '下发失败', 3: '已确认' }[v] || '-';
    },
    getSendStatusType(v) {
      return { 0: 'info', 1: 'warning', 2: 'danger', 3: 'success' }[v] || 'info';
    },
  },
  created() {
    this.deviceNo   = this.$route.query.deviceNo || '';
    this.oldmanName = this.$route.query.oldmanName || '';
    this.configForm.deviceNo = this.deviceNo;
    this.loadConfig();
  },
};
</script>

<style lang="scss" scoped>
.config-page {
  padding: 10px 5px;
  display: flex; flex-direction: column; gap: 12px;
}
.topbar {
  display: flex; align-items: center; justify-content: space-between; padding: 4px 0;
}
.topbar-left { display: flex; align-items: center; gap: 6px; }
.bc-sep { color: #c0c4cc; }
.bc-cur { font-size: 15px; font-weight: 600; color: #303133; }

.device-card { border-radius: 6px; }
.device-info {
  display: flex; align-items: center; gap: 6px; font-size: 13px; flex-wrap: wrap;
}
.device-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.device-dot.online  { background: #67c23a; }
.device-dot.offline { background: #c0c4cc; }
.device-no { font-weight: 600; }
.sep  { color: #c0c4cc; }
.meta { color: #909399; }

.section-card { border-radius: 6px; }
.section-header {
  display: flex; align-items: center; font-size: 14px; font-weight: 600;
}
.hint { margin-left: auto; font-size: 12px; font-weight: 400; color: #909399; }

.time-field { display: flex; flex-direction: column; gap: 4px; margin-bottom: 8px; }
.time-label { font-size: 12px; color: #909399; }
</style>
